import {ApiResponse} from "@models/axios";
import React from "react";
import {FormattedMessage} from 'react-intl';
import {NavigationConfiguration, NavigationButton} from '@models/navigation';

export const enum WidgetType {
    "MAIN_SLIDER"       = "main_slider",
    "WIDE_SLIDER"       = "wide_slider",
    "POSTER"            = "poster",
    "PROMOTED_CAROUSEL" = "promoted_carousel",
    "REQULAR_CAROUSEL"  = "regular_carousel",
    "ARTIST_CAROUSEL"   = "artist_carousel",
    "CATEGORY_CAROUSEL" = "category_carousel",
    "TAG_CAROUSEL"      = "tag_carousel",
    "PROMOTED_POSTER"   = "promoted_poster",
    "FRANCHISE"         = "franchise",
    "PROMOTED"          = "promoted",
    "EXCLUSIVE"         = "exclusive",
    "VITRINE"           = "vitrine",
    "CONTINUE_WATCHING" = "continue_watching",
    "ANDROID_CHANNEL"   = "android_channel",
    "LIVE_CHANNEL"      = "live_channel",
    "TEASER_VIDEO"      = "teaser_video",
}

export const WidgetTypeOptions = [{
    value: WidgetType.MAIN_SLIDER,
    label: <FormattedMessage id="app.main_slider" defaultMessage={`Mail Slider`}/>,
}, {
    value: WidgetType.WIDE_SLIDER,
    label: <FormattedMessage id="app.wide_slider" defaultMessage={`Wide Slider`}/>,
}, {
    value: WidgetType.POSTER,
    label: <FormattedMessage id="app.poster" defaultMessage={`Poster`}/>,
}, {
    value: WidgetType.PROMOTED_CAROUSEL,
    label: <FormattedMessage id="app.promoted_carousel" defaultMessage={`Promoted Carousel`}/>,
}, {
    value: WidgetType.REQULAR_CAROUSEL,
    label: <FormattedMessage id="app.regular_carousel" defaultMessage={`Regular Carousel`}/>,
}, {
    value: WidgetType.ARTIST_CAROUSEL,
    label: <FormattedMessage id="app.artist_carousel" defaultMessage={`Artist Carousel`}/>
}, {
    value: WidgetType.CATEGORY_CAROUSEL,
    label: <FormattedMessage id="app.category_carousel" defaultMessage={`Category Carousel`}/>
}, {
    value: WidgetType.TAG_CAROUSEL,
    label: <FormattedMessage id="app.tag_carousel" defaultMessage={`Tag Carousel`}/>
},{
    value: WidgetType.PROMOTED_POSTER,
    label: <FormattedMessage id="app.promoted_poster" defaultMessage={`Promoted Poster`}/>
},{
    value: WidgetType.FRANCHISE,
    label: <FormattedMessage id="app.franchise" defaultMessage={`Franchise`}/>
},{
    value: WidgetType.PROMOTED,
    label: <FormattedMessage id="app.promoted" defaultMessage={`Tree Video Promoted`}/>
},{
    value: WidgetType.EXCLUSIVE,
    label: <FormattedMessage id="app.exclusive" defaultMessage={`exclusive`}/>
}, {
    value: WidgetType.VITRINE,
    label: <FormattedMessage id="app.vitrine" defaultMessage={`vitrine`}/>,
},
{
    value: WidgetType.CONTINUE_WATCHING,
    label: <FormattedMessage id="app.continue_watching" defaultMessage={`continue watching`}/>,
},
{
    value: WidgetType.ANDROID_CHANNEL,
    label: <FormattedMessage id="app.android_channel" defaultMessage={`android channel`}/>,
},
{
    value: WidgetType.LIVE_CHANNEL,
    label: <FormattedMessage id="app.live_channel" defaultMessage={`Live Channel`}/>,
},
{
    value: WidgetType.TEASER_VIDEO,
    label: <FormattedMessage id="app.teaser_video" defaultMessage={`Teaser Video`}/>,
},
];


export interface WidgetsState {
    readonly loading: boolean
    readonly allIds: String[]
    readonly byId: object
    readonly count: number
}


export interface Widget extends ApiResponse {
    display_title: string,
    type: string,
    column: number,
    row: number,
    owner: string,
    is_active: boolean,
    id: string,
    short_id: string,
    created_at: string,
    modified_at: string,
    configuration?: any,
}

export interface WidgetItem extends ApiResponse {
    display_title: string,
    type: string,
    column: number,
    row: number,
    owner: string,
    is_active: boolean,
    id: string,
    short_id: string,
    created_at: string,
    modified_at: string,
    configuration?: any,
    iran_access?: boolean
}


export interface WidgetItem {
    title: string,
    navigation_configuration: NavigationConfiguration,
    navigation_button: NavigationButton
}


export const enum WidgetLocation {
    "HOME_PAGE" = "home_page",
    "CATEGORY" = "category",
    "PERSON" = "person",
    "TAG" = "tag",
    "LIVE_CHANNEL" = "live_channel",
    "ANDROID_CHANNEL" = "android_channel",
    "PACKAGES" = "packages",
}

export const WidgetLocationOptions = [{
    value: WidgetLocation.HOME_PAGE,
    label: <FormattedMessage id="app.home_page" defaultMessage={`Home Page`}/>,
}, {
    value: WidgetLocation.CATEGORY,
    label: <FormattedMessage id="app.specific_category" defaultMessage={`Specific Category`}/>
}, {
    value: WidgetLocation.TAG,
    label: <FormattedMessage id="app.specific_tag" defaultMessage={`Specific Tag`}/>
}, {
    value: WidgetLocation.PERSON,
    label: <FormattedMessage id="app.specific_person" defaultMessage={`Specific Person`}/>
},{
    value: WidgetLocation.LIVE_CHANNEL,
    label: <FormattedMessage id="app.live_channel_page" defaultMessage={`Live channel page`}/>
},{
    value: WidgetLocation.ANDROID_CHANNEL,
    label: <FormattedMessage id="app.android_channel_page" defaultMessage={`Android channel page`}/>
},{
    value: WidgetLocation.PACKAGES,
    label: <FormattedMessage id="app.packages_page" defaultMessage={`Packages page`}/>
}];

export const enum ClientPlatform {
    "WEB" = "web",
    "WEBTV" = "webTv",
    "ANDROID" = "android",
    "ANDROIDTV" = "androidTv",
    "IOS" = "ios",
}

export const ClientPlatformOptions = [{
    value: ClientPlatform.WEB,
    label: <FormattedMessage id="app.web" defaultMessage={`Web`}/>
}, {
    value: ClientPlatform.WEBTV,
    label: <FormattedMessage id="app.web_tv" defaultMessage={`Web Tv`}/>
}, {
    value: ClientPlatform.ANDROID,
    label: <FormattedMessage id="app.android" defaultMessage={`Android`}/>
},{
    value: ClientPlatform.ANDROIDTV,
    label: <FormattedMessage id="app.android_tv" defaultMessage={`Android Tv`}/>
},{
    value: ClientPlatform.IOS,
    label: <FormattedMessage id="app.ios" defaultMessage={`IOS`}/>
},];
